export default __webpack_public_path__ + "static/media/bp-15.a53bd8af.jpg";